/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Style_HelpInputs */



/**
* | output |
* | --- |
* | "Select the display style for captions" |
*
* @param {Caption_Style_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_help = /** @type {((inputs?: Caption_Style_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez le style d’affichage des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie den Darstellungsstil für Untertitel aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona lo stile di visualizzazione per le didascalie")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите стиль отображения для подписей.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el estilo de visualización para los subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择字幕的显示样式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプションの表示スタイルを選択する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन के लिए डिस्प्ले स्टाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o estilo de exibição para as legendas.")
	return /** @type {LocalizedString} */ ("Select the display style for captions")
});